import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_x9wh59mbc7: FaireBrandEntity = {
  token: "b_x9wh59mbc7",
  type: "brand",
  name: "Cachet",
  avatarUrl:
    "https://cdn.faire.com/fastly/d407234f9e849614f6159722d68555002e2443af1b3b0b33123239d83092f992.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3272b1c28a5c8d89a4d018e75bdd4d063ff2754b0b5395eaeacdaeab0784005a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d407234f9e849614f6159722d68555002e2443af1b3b0b33123239d83092f992.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3272b1c28a5c8d89a4d018e75bdd4d063ff2754b0b5395eaeacdaeab0784005a.jpeg",
  location: "Sugar Loaf, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi, we are Melanie and Tim Brown. Together we run Cachet Home Market, an artisan candle and perfumes studio in the Hudson Valley. We are both artists and both have a love of nostalgia and timeless eclecticism that we bring into creating home and personal fragrances.\n\nWe started in 2022 and ventured into the world of scents to channel our creativity, and capture the nostalgic beauty of cherished moments. Candles allow us to fill the room with the memory of those moments. To take it further, we created our own line of personal fragrances. Our luxurious eaux de parfum, like all our products, are entirely handcrafted by us, from the creation of the scents, to the blending and bottling. \n\nWe created our refillable candles to reflect our desire to cherish decorative objets as a long term part of life, while offering a sustainable way to scent the home by reducing waste and carbon footprint.",
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:42.007Z",
    importedBy: "entity-db-cli",
  },
};
